import React, { Component, HTMLProps, ReactNode } from 'react';

import styles from './default.less';

interface Props extends Omit<HTMLProps<HTMLInputElement>, 'onChange'> {
	checked: boolean;
	children: ReactNode;
	disabled: boolean;
	focused: boolean;
	name: string;
	onChange(checked: boolean, event: React.MouseEvent<HTMLLabelElement>): void;
}

export default class Checkbox extends Component<Props> {
	public static defaultProps = {
		checked: false,
		children: null,
		disabled: false,
		focused: false,
		name: null,
	};

	public render() {
		const { id, name, children, checked, focused, disabled } = this.props;

		return (
			<label className={styles.label} htmlFor={id} onClick={disabled ? undefined : this.clicked}>
				<input
					className={styles.input}
					disabled={disabled}
					checked={checked}
					id={id}
					name={name}
					type='checkbox'
					onChange={() => null}
				/>
				<span className={focused ? styles.focusedContainer : styles.container}>
					<span className={styles.checkbox} data-testid='checkbox' />
				</span>
				{children}
			</label>
		);
	}

	private readonly clicked = (event: React.MouseEvent<HTMLLabelElement>) => {
		const { checked, onChange } = this.props;
		event.preventDefault();
		onChange(!checked, event);
	};
}
